import $  from 'jquery';
import Reflux from 'reflux';
import ErrorActions from './actions';

export default class ErrorMessagesStore extends Reflux.Store {
  constructor() {
    super();
    this.state = this.getInitialState();
    this.listenables = ErrorActions;
  }
  getInitialState() {
    return {
      "errors":[]
    }
  }
  onUpdate(messages) {
    this.setState({
      errors: messages
    })
  }
}



// WEBPACK FOOTER //
// ./medscape_modules/email-modal/error-messages/store.js